export const homeData = {
  hero: {
    title: "爱威奶",
    subtitle: "呵护每一刻，品质新选择",
    description: "爱威奶以卓越品质与贴心设计，成为万千家庭的信赖之选。从科学配方到严格品控，每一步都为您的健康护航。",
    cta: "立即了解",
    ctaSecondary: "查看用户口碑",
  },
  advantages: {
    sectionTitle: "核心优势",
    sectionSubtitle: "为什么选择爱威奶？六大优势为您保驾护航",
    items: [
      {
        icon: "ri-shield-check-line",
        title: "品质保障",
        description: "严选优质原料，通过国家多项质量认证，从源头保障每一滴爱威奶的纯净与安全。",
      },
      {
        icon: "ri-flask-line",
        title: "科学配方",
        description: "由专业营养师团队精心研发，科学配比多种营养成分，满足不同人群的日常所需。",
      },
      {
        icon: "ri-leaf-line",
        title: "天然健康",
        description: "坚持天然原料，不添加人工色素和防腐剂，守护您和家人的健康生活。",
      },
      {
        icon: "ri-truck-line",
        title: "新鲜速达",
        description: "全程冷链物流体系，从生产到配送严格控温，确保产品以最佳状态送达您的手中。",
      },
      {
        icon: "ri-user-heart-line",
        title: "贴心服务",
        description: "专业客服团队全天候在线，为您解答使用疑问，提供个性化的产品推荐与指导。",
      },
      {
        icon: "ri-medal-line",
        title: "口碑之选",
        description: "累计服务超过100万家庭，用户满意度高达98.6%，用真实口碑见证品牌实力。",
      },
    ],
  },
  scenarios: {
    sectionTitle: "使用场景",
    sectionSubtitle: "爱威奶融入日常生活的每一个重要时刻",
    items: [
      {
        icon: "ri-sun-line",
        title: "早餐营养搭配",
        description: "每天清晨一杯爱威奶，搭配面包或麦片，开启元气满满的一天，为身体注入活力。",
      },
      {
        icon: "ri-parent-line",
        title: "成长关键期",
        description: "儿童和青少年在生长发育阶段，爱威奶提供全面均衡营养，助力健康成长。",
      },
      {
        icon: "ri-heart-pulse-line",
        title: "中老年养护",
        description: "针对中老年人群体，爱威奶特别添加高钙与多种微量元素，守护骨骼与心血管健康。",
      },
      {
        icon: "ri-restaurant-line",
        title: "餐后营养补充",
        description: "作为餐后饮品，爱威奶帮助更好地吸收营养，是全家人的健康好搭档。",
      },
      {
        icon: "ri-run-line",
        title: "运动恢复",
        description: "运动后饮用爱威奶，快速补充蛋白质和能量，加速身体恢复，提升运动效果。",
      },
      {
        icon: "ri-moon-line",
        title: "睡前助眠",
        description: "温热的爱威奶含有助眠成分，睡前饮用可帮助放松身心，享受优质睡眠体验。",
      },
    ],
  },
  reviews: {
    sectionTitle: "用户口碑",
    sectionSubtitle: "真实用户分享，见证爱威奶的品质力量",
    items: [
      {
        name: "张女士",
        location: "北京",
        rating: 5,
        content: "给孩子喝爱威奶已经半年了，口感好、营养全面，孩子很喜欢，体检指标也明显改善。强烈推荐！",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2030s%20with%20warm%20smile%20against%20simple%20cream%20colored%20studio%20background%20soft%20natural%20lighting%20clean%20minimal%20aesthetic&width=200&height=200&seq=review-avatar-01&orientation=squarish",
      },
      {
        name: "李先生",
        location: "上海",
        rating: 5,
        content: "父母年纪大了，一直在找适合的营养品。爱威奶的成分科学、易于吸收，父母反馈很好，会继续回购。",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2040s%20with%20confident%20smile%20against%20simple%20cream%20colored%20studio%20background%20soft%20natural%20lighting%20clean%20minimal%20aesthetic&width=200&height=200&seq=review-avatar-02&orientation=squarish",
      },
      {
        name: "王女士",
        location: "广州",
        rating: 5,
        content: "作为健身爱好者，运动后喝爱威奶恢复特别快。口感和营养都很棒，已经推荐给健身房的很多伙伴了！",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2020s%20with%20bright%20smile%20against%20simple%20cream%20colored%20studio%20background%20soft%20natural%20lighting%20clean%20minimal%20aesthetic&width=200&height=200&seq=review-avatar-03&orientation=squarish",
      },
      {
        name: "赵先生",
        location: "深圳",
        rating: 5,
        content: "从孕期到哺乳期一直在用爱威奶，品质让人放心，营养成分标注清晰，是新手父母的安心之选。",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2030s%20with%20gentle%20smile%20against%20simple%20cream%20colored%20studio%20background%20soft%20natural%20lighting%20clean%20minimal%20aesthetic&width=200&height=200&seq=review-avatar-04&orientation=squarish",
      },
      {
        name: "陈女士",
        location: "成都",
        rating: 5,
        content: "口感细腻醇厚，奶香浓郁但不腻，全家人都爱喝。包装设计也很贴心，送礼自用都合适。",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2030s%20with%20warm%20friendly%20smile%20against%20simple%20cream%20colored%20studio%20background%20soft%20natural%20lighting%20clean%20minimal%20aesthetic&width=200&height=200&seq=review-avatar-05&orientation=squarish",
      },
    ],
  },
  buyingGuide: {
    sectionTitle: "购买指南",
    sectionSubtitle: "三步轻松购买爱威奶，享受品质生活",
    steps: [
      {
        number: "01",
        title: "选择产品",
        description: "根据您的需求和家庭成员情况，选择适合的爱威奶产品系列与规格。",
        icon: "ri-shopping-bag-3-line",
      },
      {
        number: "02",
        title: "下单订购",
        description: "通过官方渠道下单，支持多种支付方式，订单确认后立即进入配送流程。",
        icon: "ri-order-play-line",
      },
      {
        number: "03",
        title: "收货享用",
        description: "全程冷链配送，新鲜直达。收到后请按说明储存，即刻开启健康品质生活。",
        icon: "ri-home-smile-line",
      },
    ],
  },
  faq: {
    sectionTitle: "常见问题",
    sectionSubtitle: "关于爱威奶，您想了解的一切都在这里",
    items: [
      {
        question: "爱威奶适合哪些人群使用？",
        answer: "爱威奶适合全年龄段人群，包括儿童、青少年、成年人及中老年人。特别针对不同年龄段推出了针对性的营养配方，满足各阶段人群的不同营养需求。",
      },
      {
        question: "爱威奶的保质期是多久？如何储存？",
        answer: "爱威奶未开封状态下保质期为12个月。建议存放于阴凉干燥处，避免阳光直射。开封后请密封保存并于30天内饮用完毕，冷藏效果更佳。",
      },
      {
        question: "爱威奶的使用方法是什么？",
        answer: "建议每日饮用200-300ml，可直接饮用或温热后饮用（温度不超过60℃）。可搭配早餐、作为餐后饮品或运动后补充。请根据个人口味和需求适量调整。",
      },
      {
        question: "爱威奶与其他同类产品相比有什么优势？",
        answer: "爱威奶采用科学配方和天然原料，不添加人工色素和防腐剂。经过严格品控，拥有多项国家质量认证。同时我们建立了完善的冷链物流体系和专业的客服团队，确保产品品质和服务体验。",
      },
      {
        question: "爱威奶在哪里可以购买？",
        answer: "爱威奶可通过官方网站在线订购，也可在全国各大商超、母婴店和药店购买。建议选择官方授权渠道，确保购买到正品，享受完善的售后服务保障。",
      },
      {
        question: "爱威奶是否适合乳糖不耐受人群？",
        answer: "爱威奶特别推出了低乳糖配方系列，适合乳糖不耐受人群饮用。如果您对乳制品过敏或有特殊体质，建议在饮用前咨询医生或专业营养师的意见。",
      },
      {
        question: "爱威奶的配送范围和时效是怎样的？",
        answer: "爱威奶目前已覆盖全国主要城市，一二线城市通常下单后24-48小时内送达，其他地区3-5个工作日送达。我们采用全程冷链物流，确保产品品质不受影响。",
      },
    ],
  },
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "产品分类", href: "/category/all" },
  { label: "使用指南", href: "/category/guide" },
  { label: "用户评测", href: "/category/review" },
  { label: "关于我们", href: "/about" },
];